<template>
  <div>
    <form role="form" @submit.prevent="onSubmit" v-if="status === 0">
      <app-input-text v-model="user.email" label="E-mail" c_css value />
      <div class="text-center">
        <button type="submit" class="btn btn-primary w-100 waves-effect waves-light"
          :disabled="isSubmitButtonDisabled">Recuperar</button>
      </div>
    </form>
    <form role="form" @submit.prevent="onValidCode" v-else-if="status === 1">
      <p>Use o código recebido em seu e-mail cadatrado e em seguida escolha sua nova senha de acesso.</p>
      <app-input-code @input="setCode" />
      <app-input-password v-model="pwd" label="Nova senha" c_css />
      <div class="text-center">
        <button type="submit" class="btn btn-primary w-100 waves-effect waves-light"
          :disabled="!code || !pwd">Alterar</button>
      </div>
    </form>
  </div>

</template>
<script>
import AppInputText from "@/components/AppInputText/AppInputText.vue";
import AppInputCode from "@/components/AppInputText/AppInputCode.vue";
import AppInputPassword from "@/components/AppInputPassword/AppInputPassword.vue";
import { mapActions, mapMutations } from "vuex";
import useSubmitButtonState from "@/modules/useSubmitButtonState";
import { reactive } from "vue";

export default {
  setup() {
    const user = reactive({
      email: ""
    });
    const { isSubmitButtonDisabled } = useSubmitButtonState(user);
    return { user, isSubmitButtonDisabled };
  },
  components: {
    AppInputText,
    AppInputPassword,
    AppInputCode
  },
  data() {
    return {
      successMessage: "Um código foi enviado para o e-mail.",
      status: 0,
      code: '',
      pwd: '',
    };
  },
  created() {
    if (this.emailDefault) {
      this.user.email = this.emailDefault;
    }
  },
  methods: {
    ...mapActions([
      "showMessage",
      "showLoader",
      "setLoaderTitle",
      "showBlockScreen"
    ]),
    setCode(val){
      this.code = val
    },
    onAction(email) {
      this.$emit("actionChange", email);
    },
    onLoader(val) {
      if (this.destiny === "login") {
        this.showLoader(val);
      }
    },
    async onValidCode() {
      this.onLoader(true);
      const data = { token: this.code, password: this.pwd };
      const { url, options } = this.$getAPIHeadersFetch("POST", `new-password-token`, data);
      try {
        const response = await fetch(url, options);
        const result = await response.json();

        if (result.status === 200 || result.status === 201) {
          this.showMessage({
            title: result.message,
            css: "bg-success"
          });
          const _that = this;
          setTimeout(function(){
             _that.$router.push('/')
          }, 2000);
        } else if (result.status === 400) {

          this.showMessage({
            title: result.message,
            css: "bg-danger"
          });

        } else {
          this.showMessage({
            title: "Desculpe um erro aconteceu, por favor, tente novamente...",
            css: "bg-danger"
          });
        }


      } catch (error) {
        this.showMessage({
          title: "Desculpe um erro aconteceu, por favor, tente novamente.",
          css: "bg-danger"
        });
        this.status = 0;
      } finally {
        this.showLoader(false);
      }
    },
    async onSubmit() {
      this.showLoader(true);
      const data = { email: this.user.email };
      const { url, options } = this.$getAPIHeadersFetch("POST", "forgot-password-token", data);
      try {
        const response = await fetch(url, options);
        const result = await response.json();

        if (result.status === 200 || result.status === 201) {
          this.showMessage({
            title: result.message || "Um código foi enviado para o e-mail.",
            css: "bg-success"
          });
          this.status = 1;
        } else if (result.status === 400) {

          this.showMessage({
            title: result.message || "Erro ao enviar código. Tente novamente.",
            css: "bg-danger"
          });

        } else {
          this.showMessage({
            title: "Desculpe um erro aconteceu, por favor, tente novamente...",
            css: "bg-danger"
          });
        }


      } catch (error) {
        this.showMessage({
          title: "Desculpe um erro aconteceu, por favor, tente novamente.",
          css: "bg-danger"
        });
        this.status = 0;
      } finally {
        this.showLoader(false);
      }
    },
    async sonSubmit() {
      this.onLoader(true);
      const data = { email: this.user.email };
      const headers = this.$getAPIHeaders("POST", "forgot-password-token", data);
      try {
        const response = await this.axios(headers);

        if (response.status >= 200 && response.status < 300) {
          // sucesso
          this.showMessage({
            title: response.data.message,
            css: "bg-success"
          });
          this.status = 1;
        } else {
          // qualquer HTTP fora da faixa
          this.showMessage({
            title: response.data.message || "Erro ao enviar código. Tente novamente.",
            css: "bg-danger"
          });
          this.status = 0;
        }
      } catch (error) {
        // apenas erros de conexão, timeout etc
        this.showMessage({
          title: "Erro de comunicação. Tente novamente.",
          css: "bg-danger"
        });
        this.status = 0;
      } finally {
        this.onLoader(false);
      }
    }
  }
};
</script>